import { Component } from 'react';
import { Link } from 'react-router-dom';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[var(--cv-bg)] flex flex-col items-center justify-center gap-6 px-6">
          <h1 className="text-2xl font-bold uppercase tracking-wider" style={{ fontFamily: 'var(--font-heading)' }}>
            Something went wrong
          </h1>
          <p className="text-[var(--cv-text-dim)] text-sm text-center max-w-md">
            An unexpected error occurred. Please try refreshing the page.
          </p>
          <Link
            to="/"
            onClick={() => this.setState({ hasError: false })}
            className="bg-white text-black px-6 py-2.5 text-xs uppercase tracking-widest font-semibold hover:bg-gray-200 transition-colors"
            data-testid="error-home-link"
          >
            Back to Home
          </Link>
        </div>
      );
    }
    return this.props.children;
  }
}
